import { render, staticRenderFns } from "./CreateMarketingModal.vue?vue&type=template&id=57b66739"
import script from "./CreateMarketingModal.vue?vue&type=script&lang=js"
export * from "./CreateMarketingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports